import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import { toggleSwitch } from '../../actions/index'
import { _ } from '../../functions/translator.js'
import { ToggleActions } from '../../constants/constants.js';

class BuildingLoadSwitch extends React.Component{

    handleOnClick = () => {
        this.props.toggleSwitch(ToggleActions.FULL_BUILDING)
    };

    render() {
        return(
            <div className="ml-3 mt-2">
                <FormGroup row>
                <FormControlLabel
                    className="text"
                    control={
                    <Switch
                        checked={this.props.fullBuilding}
                        onChange={this.handleOnClick}
                        color="primary"
                    />
                    }
                    label={ _('Modelo 3D') }
                />
                </FormGroup>
            </div>
        );
    } 
}

function mapStateToProps( state ){
    return {
        fullBuilding : state.switches.fullBuilding,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        toggleSwitch : toggleSwitch,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(BuildingLoadSwitch);